import React, { createContext, useContext } from 'react';
import { useLocalDataTrack, } from '@alucio/video';
export const DatatrackContext = createContext(null);
DatatrackContext.displayName = 'DatatrackContext';
const DatatrackProvider = (props) => {
    const localDataTrack = useLocalDataTrack();
    /**
     * This is the primary facility for emitting datatrack messages via the twilio api
     * @param msg DatatrackMsg
     */
    const emitDatatrackMsg = (msg) => {
        const jsonMsg = JSON.stringify(msg);
        localDataTrack === null || localDataTrack === void 0 ? void 0 : localDataTrack.send(jsonMsg);
    };
    const contextValue = {
        emitDatatrackMsg,
    };
    return (React.createElement(DatatrackContext.Provider, { value: contextValue }, props.children));
};
DatatrackProvider.displayName = 'DatatrackProvider';
export function useDatatrackContext() {
    const context = useContext(DatatrackContext);
    if (!context) {
        throw new Error('useDatatrack must be used within the DatatrackProvider');
    }
    return context;
}
export default DatatrackProvider;
//# sourceMappingURL=index.js.map